import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=fade2aac&scoped=true&"
import script from "../assets/js/Reports.js?vue&type=script&lang=js&"
export * from "../assets/js/Reports.js?vue&type=script&lang=js&"
import style0 from "./Reports.vue?vue&type=style&index=0&id=fade2aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fade2aac",
  null
  
)

export default component.exports